// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wbs-page {
  min-height: 100%;
  padding: 32px;
  box-sizing: border-box;
  background: #030712;
  color: white;
}

.wbs-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto 20px;
}

.wbs-header h1 { margin: 0 0 8px; }
.wbs-header p { margin: 0; color: #94a3b8; }
.wbs-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.wbs-actions button, .wbs-node-actions button {
  border: 1px solid rgba(255,255,255,0.16);
  border-radius: 10px;
  padding: 10px 14px;
  background: rgba(255,255,255,0.07);
  color: white;
  cursor: pointer;
}
.wbs-actions button.primary { background: #4f46e5; border-color: #4f46e5; }
.wbs-actions button.requirements {
  background: #0f766e;
  border-color: #14b8a6;
}
.wbs-actions button.tasks {
  background: #1d4ed8;
  border-color: #60a5fa;
}
.wbs-actions button.save {
  background: #166534;
  border-color: #22c55e;
}
.wbs-actions button:disabled { opacity: 0.45; cursor: default; }
.wbs-status {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto 14px;
  padding: 11px 16px;
  border: 1px solid rgba(34,197,94,0.25);
  border-radius: 10px;
  background: rgba(22,101,52,0.14);
  color: #bbf7d0;
}
.wbs-status.unsaved {
  border-color: rgba(245,158,11,0.35);
  background: rgba(146,64,14,0.18);
  color: #fde68a;
}
.wbs-requirements-warning {
  max-width: 1400px;
  margin: 0 auto 14px;
  padding: 12px 16px;
  border: 1px solid rgba(251,191,36,0.4);
  border-radius: 10px;
  background: rgba(120,53,15,0.25);
  color: #fde68a;
}
.wbs-message {
  max-width: 1400px;
  margin: 0 auto 18px;
  padding: 12px 16px;
  border-radius: 10px;
  background: rgba(79,70,229,0.15);
  color: #cbd5e1;
}
.wbs-empty-state {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  width: min(1000px, 100%);
  margin: 60px auto;
}
.wbs-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 300px;
  border: 2px dashed rgba(255,255,255,0.2);
  border-radius: 20px;
  background: rgba(255,255,255,0.03);
  color: white;
  cursor: pointer;
  justify-content: center;
}
.wbs-dropzone.requirements {
  border-color: rgba(45, 212, 191, 0.45);
  background: rgba(13, 148, 136, 0.12);
}
.wbs-dropzone.tasks {
  border-color: rgba(96, 165, 250, 0.45);
  background: rgba(29, 78, 216, 0.12);
}
.wbs-dropzone strong { font-size: 24px; }
.wbs-dropzone span { color: #94a3b8; }
.wbs-root-drop {
  max-width: 1400px;
  margin: 0 auto 10px;
  padding: 8px;
  border: 1px dashed transparent;
  border-radius: 8px;
  color: transparent;
  text-align: center;
  transition: 0.2s ease;
}
.wbs-root-drop.active {
  border-color: #6366f1;
  color: #a5b4fc;
}
.wbs-canvas-shell {
  max-width: 1400px;
  margin: 0 auto;
  overflow: auto;
  min-height: 560px;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 18px;
  background: #0f172a;
}
.wbs-canvas { position: relative; }
.wbs-lines { position: absolute; inset: 0; pointer-events: none; }
.wbs-lines polyline { stroke: #64748b; stroke-width: 2; fill: none; }
.wbs-project-node {
  position: absolute;
  width: 440px;
  height: 100px;
  padding: 14px 18px 10px;
  box-sizing: border-box;
  border: 1px solid #263f78;
  border-radius: 12px;
  background: #061a46;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}
.wbs-project-node textarea {
  display: block;
  width: 100%;
  height: 54px;
  padding: 0;
  border: 0;
  background: transparent;
  color: white;
  font: 800 22px/1.25 Arial, sans-serif;
  text-align: center;
  resize: none;
  outline: none;
}
.wbs-project-node button {
  display: block;
  margin: 2px auto 0;
  padding: 4px 10px;
  border: 1px solid rgba(255,255,255,0.28);
  border-radius: 6px;
  background: rgba(255,255,255,0.1);
  color: white;
  font-size: 11px;
  cursor: pointer;
}
.wbs-node {
  position: absolute;
  width: 210px;
  height: 76px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #6366f1;
  border-radius: 12px;
  background: #111827;
  cursor: grab;
  box-shadow: 0 8px 24px rgba(0,0,0,0.25);
  transition: opacity .15s ease, transform .15s ease;
}
.wbs-node:active { cursor: grabbing; opacity: .55; transform: scale(.98); }
.wbs-node.epic {
  border-color: #7ac99a;
  background: #edf7eb;
}
.wbs-node.epic input {
  color: #0f172a;
}
.wbs-node.task {
  border-color: #b9d8c6;
  background: #f8fafc;
}
.wbs-node.task input {
  color: #0f172a;
}
.wbs-node.epic .wbs-node-actions button,
.wbs-node.task .wbs-node-actions button {
  border-color: rgba(15,23,42,0.16);
  color: #334155;
}
.wbs-node input {
  width: 100%;
  border: 0;
  border-bottom: 1px solid rgba(255,255,255,0.12);
  padding: 2px 0 7px;
  background: transparent;
  color: white;
  font-weight: 700;
  outline: none;
}
.wbs-node-actions { display: flex; gap: 6px; margin-top: 7px; }
.wbs-node-actions button { padding: 4px 7px; border-radius: 6px; font-size: 11px; }

@media (max-width: 900px) {
  .wbs-header { flex-direction: column; }
  .wbs-empty-state { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WbsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB,eAAe,EAAE;AAClC,gBAAgB,SAAS,EAAE,cAAc,EAAE;AAC3C,eAAe,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1D;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;AACA,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE;AAC1E;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,+BAA+B,aAAa,EAAE,eAAe,EAAE;AAC/D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;AACA,uBAAuB,eAAe,EAAE;AACxC,qBAAqB,cAAc,EAAE;AACrC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,cAAc,kBAAkB,EAAE;AAClC,aAAa,kBAAkB,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AACjE,sBAAsB,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE;AACpE;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,kDAAkD;AACpD;AACA,mBAAmB,gBAAgB,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAC1E;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,WAAW;EACX,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA,oBAAoB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC9D,2BAA2B,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAElF;EACE,cAAc,sBAAsB,EAAE;EACtC,mBAAmB,0BAA0B,EAAE;AACjD","sourcesContent":[".wbs-page {\n  min-height: 100%;\n  padding: 32px;\n  box-sizing: border-box;\n  background: #030712;\n  color: white;\n}\n\n.wbs-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  max-width: 1400px;\n  margin: 0 auto 20px;\n}\n\n.wbs-header h1 { margin: 0 0 8px; }\n.wbs-header p { margin: 0; color: #94a3b8; }\n.wbs-actions { display: flex; gap: 10px; flex-wrap: wrap; }\n.wbs-actions button, .wbs-node-actions button {\n  border: 1px solid rgba(255,255,255,0.16);\n  border-radius: 10px;\n  padding: 10px 14px;\n  background: rgba(255,255,255,0.07);\n  color: white;\n  cursor: pointer;\n}\n.wbs-actions button.primary { background: #4f46e5; border-color: #4f46e5; }\n.wbs-actions button.requirements {\n  background: #0f766e;\n  border-color: #14b8a6;\n}\n.wbs-actions button.tasks {\n  background: #1d4ed8;\n  border-color: #60a5fa;\n}\n.wbs-actions button.save {\n  background: #166534;\n  border-color: #22c55e;\n}\n.wbs-actions button:disabled { opacity: 0.45; cursor: default; }\n.wbs-status {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  max-width: 1400px;\n  margin: 0 auto 14px;\n  padding: 11px 16px;\n  border: 1px solid rgba(34,197,94,0.25);\n  border-radius: 10px;\n  background: rgba(22,101,52,0.14);\n  color: #bbf7d0;\n}\n.wbs-status.unsaved {\n  border-color: rgba(245,158,11,0.35);\n  background: rgba(146,64,14,0.18);\n  color: #fde68a;\n}\n.wbs-requirements-warning {\n  max-width: 1400px;\n  margin: 0 auto 14px;\n  padding: 12px 16px;\n  border: 1px solid rgba(251,191,36,0.4);\n  border-radius: 10px;\n  background: rgba(120,53,15,0.25);\n  color: #fde68a;\n}\n.wbs-message {\n  max-width: 1400px;\n  margin: 0 auto 18px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: rgba(79,70,229,0.15);\n  color: #cbd5e1;\n}\n.wbs-empty-state {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  width: min(1000px, 100%);\n  margin: 60px auto;\n}\n.wbs-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 300px;\n  border: 2px dashed rgba(255,255,255,0.2);\n  border-radius: 20px;\n  background: rgba(255,255,255,0.03);\n  color: white;\n  cursor: pointer;\n  justify-content: center;\n}\n.wbs-dropzone.requirements {\n  border-color: rgba(45, 212, 191, 0.45);\n  background: rgba(13, 148, 136, 0.12);\n}\n.wbs-dropzone.tasks {\n  border-color: rgba(96, 165, 250, 0.45);\n  background: rgba(29, 78, 216, 0.12);\n}\n.wbs-dropzone strong { font-size: 24px; }\n.wbs-dropzone span { color: #94a3b8; }\n.wbs-root-drop {\n  max-width: 1400px;\n  margin: 0 auto 10px;\n  padding: 8px;\n  border: 1px dashed transparent;\n  border-radius: 8px;\n  color: transparent;\n  text-align: center;\n  transition: 0.2s ease;\n}\n.wbs-root-drop.active {\n  border-color: #6366f1;\n  color: #a5b4fc;\n}\n.wbs-canvas-shell {\n  max-width: 1400px;\n  margin: 0 auto;\n  overflow: auto;\n  min-height: 560px;\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 18px;\n  background: #0f172a;\n}\n.wbs-canvas { position: relative; }\n.wbs-lines { position: absolute; inset: 0; pointer-events: none; }\n.wbs-lines polyline { stroke: #64748b; stroke-width: 2; fill: none; }\n.wbs-project-node {\n  position: absolute;\n  width: 440px;\n  height: 100px;\n  padding: 14px 18px 10px;\n  box-sizing: border-box;\n  border: 1px solid #263f78;\n  border-radius: 12px;\n  background: #061a46;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n}\n.wbs-project-node textarea {\n  display: block;\n  width: 100%;\n  height: 54px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: white;\n  font: 800 22px/1.25 Arial, sans-serif;\n  text-align: center;\n  resize: none;\n  outline: none;\n}\n.wbs-project-node button {\n  display: block;\n  margin: 2px auto 0;\n  padding: 4px 10px;\n  border: 1px solid rgba(255,255,255,0.28);\n  border-radius: 6px;\n  background: rgba(255,255,255,0.1);\n  color: white;\n  font-size: 11px;\n  cursor: pointer;\n}\n.wbs-node {\n  position: absolute;\n  width: 210px;\n  height: 76px;\n  padding: 10px;\n  box-sizing: border-box;\n  border: 1px solid #6366f1;\n  border-radius: 12px;\n  background: #111827;\n  cursor: grab;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.25);\n  transition: opacity .15s ease, transform .15s ease;\n}\n.wbs-node:active { cursor: grabbing; opacity: .55; transform: scale(.98); }\n.wbs-node.epic {\n  border-color: #7ac99a;\n  background: #edf7eb;\n}\n.wbs-node.epic input {\n  color: #0f172a;\n}\n.wbs-node.task {\n  border-color: #b9d8c6;\n  background: #f8fafc;\n}\n.wbs-node.task input {\n  color: #0f172a;\n}\n.wbs-node.epic .wbs-node-actions button,\n.wbs-node.task .wbs-node-actions button {\n  border-color: rgba(15,23,42,0.16);\n  color: #334155;\n}\n.wbs-node input {\n  width: 100%;\n  border: 0;\n  border-bottom: 1px solid rgba(255,255,255,0.12);\n  padding: 2px 0 7px;\n  background: transparent;\n  color: white;\n  font-weight: 700;\n  outline: none;\n}\n.wbs-node-actions { display: flex; gap: 6px; margin-top: 7px; }\n.wbs-node-actions button { padding: 4px 7px; border-radius: 6px; font-size: 11px; }\n\n@media (max-width: 900px) {\n  .wbs-header { flex-direction: column; }\n  .wbs-empty-state { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
